import React, { useRef } from "react";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { Modal, Button } from "react-bootstrap";

type Props = {
  show: boolean;
  imageUrl: string | null;
  aspectRatio: number;
  outputSize?: { width: number; height: number };
  onCrop: (file: File) => void;
  onCancel: () => void;
};

const CropperModal: React.FC<Props> = ({
  show,
  imageUrl,
  aspectRatio,
  outputSize,
  onCrop,
  onCancel,
}) => {
  const cropperRef = useRef<any>(null);

  const handleCrop = () => {
    const cropper = cropperRef.current?.cropper;
    if (!cropper) return;

     const options: any = {};
  if (outputSize?.width && outputSize?.width >0) options.width = outputSize.width;
  if (outputSize?.height &&  outputSize?.width >0) options.height = outputSize.height;

    cropper
      .getCroppedCanvas(options)
      .toBlob((blob: any) => {
        if (blob) {
          const file = new File([blob], "cropped.jpg", { type: "image/jpeg" });
          onCrop(file);
        }
      });
  };

  return (
    <Modal show={show} onHide={onCancel} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Crop Image</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {imageUrl && (
          <Cropper
            src={imageUrl}
            style={{ height: 400, width: "100%" }}
            initialAspectRatio={aspectRatio}
            aspectRatio={aspectRatio}
            viewMode={1}
            guides={true}
            dragMode="move"
            ref={cropperRef}
          />
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleCrop}>
          Crop
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CropperModal;
